import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { TokenExConfigResponse } from '../models/tokenex.model';

@Injectable({
  providedIn: 'root'
})

export class TokenExService {
  readonly styles = {
    base: 'font-family: Roboto, Helvetica Neue, sans-serif;padding: 0 8px;border: 1px solid rgba(0, 0, 0, 0.2);margin: 0;width: 100%;font-size: 13px;line-height: 30px;height: 40px;box-sizing: border-box;-moz-box-sizing: border-box;',
    focus: 'border: 2px solid rgba(0, 132, 255, 0.5);outline: 0;',
    error: 'border: 2px solid #f44336;',
  };

  constructor(private readonly http: HttpClient) {
  }

  getAuthenticationKey(idToken: string) {
    return this.http.get(`${environment.cardUrl}/cardapi/accountservice/api/v1/token`, {
      headers: { Authorization: `Bearer ${idToken}` }
    });
  }

  validateCardAccount(payload: unknown, idToken: string) {
    return this.http.post(`${environment.cardUrl}/cardapi/accountservice/api/v1/validateTokenized`, payload, {
      headers: { Authorization: `Bearer ${idToken}` }
    });
  }

  tokenExConfigMapper(payload: TokenExConfigResponse) {
    return {
      origin: payload.origin,
      timestamp: payload.timeStamp,
      tokenExID: payload.tokenExId,
      tokenScheme: payload.tokenScheme,
      authenticationKey: payload.authenticationKey,
      pci: payload.pci,
      styles: this.styles,
      maskInput: true,
      debug: true
    };
  }
}
